import React from 'react'
import { Typography } from '@material-ui/core'

const SelectedSchool = props => {
  const { school } = props
  const { address, zipCode, place } = school?.details?.visitAddress || {}
  const hasAddress = address || zipCode || place

  return (
    <>
      <Typography gutterBottom component="p" variant="h4">
        {school.orgNr && school.name}
      </Typography>
      {hasAddress && (
        <Typography component="p" variant="body1">
          {[address, [zipCode, place].filter(Boolean).join(' ')].filter(Boolean).join('\n')}
        </Typography>
      )}
      <Typography component="p" variant="body1">
        Org. nr: {school.orgNr && school.orgNr}
      </Typography>
      <Typography component="p" variant="body1">
        E-post: {school.email && school.email}
      </Typography>
    </>
  )
}

export default SelectedSchool
